import {Space, Tooltip} from 'antd';
import cn from 'classnames';
import {get} from 'lodash-es';
import React, {FC, MouseEvent} from 'react';
import {useDispatch} from 'react-redux';

import {DynamicIcon} from 'components/dynamic-icon';
import {TIconType} from 'components/dynamic-icon/dynamic-icon';
import {IFieldMeta, TFieldStructureType} from 'entities/metadata';
import {ECommonMessages} from 'shared/constants/messages';
import {useUserRoleFunctions} from 'shared/hooks/use-user-role-functions';
import {downloadFile, showMessage, showMessageFromResponse} from 'shared/utils';
import {openModal} from 'store/slices/modals-slice';
import {EUserRoleFunction} from 'store/slices/user-slice/user-slice-role-functions';


import './icon-cell.less';

interface IIconsCellProps {
    field: IFieldMeta;
    record: Record<string, any>;
}

export const IconsCell: FC<IIconsCellProps> = ({
    field, record,
}: IIconsCellProps) => {
    const dispatch = useDispatch();
    const {fieldStructure, modalName, modalEntityName} = field;
    const {hasUserRoleFunction: hasModalUserRole} = useUserRoleFunctions({sections: [modalEntityName ?? '']})

    const renderIcons = () => fieldStructure?.map(({
        fieldKey,
        iconName,
        prefixForField = '',
        hideLabel = false,
        referenceUrl = '',
        iconColor,
        iconSize,
    }: TFieldStructureType) => {
        const content = get(record, fieldKey, '');
        const title = prefixForField + content;
        const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
            event.stopPropagation();
            if (modalName && modalEntityName) {
                if (hasModalUserRole(EUserRoleFunction.VIEW)){
                    dispatch(openModal({
                        modalName,
                        entityName: modalEntityName,
                        modalParameters: {id: record.id, referenceUrl},
                    }));
                } else {
                    showMessage({message: 'Недостаточно прав для просмотра', isError: true});
                }

                return;
            }
            if (referenceUrl) {
                const link = `${referenceUrl}/${record.id}`;
                downloadFile(link, content).then(data => {
                    if (data.status === 200) {
                        showMessageFromResponse({
                            response: data,
                            isError: false,
                            customMessage: ECommonMessages.DOWNLOAD_FILE_SUCCESS,
                        });
                    }
                }).catch(error => {
                    showMessageFromResponse({response: error?.response, isError: true});
                });
            }
        };
        return (content || (modalName && modalEntityName)) && (!hideLabel ? (
            <Tooltip
                key={fieldKey}
                placement="top"
                title={title}
            >
                <DynamicIcon
                    className={cn('icon-cell', 'icon-cell--clickable')}
                    style={iconSize || iconColor ? {fontSize: iconSize, color: iconColor} : undefined}
                    type={iconName as TIconType}
                    onClick={handleClick}
                />
            </Tooltip>
        ) : (
            <DynamicIcon
                className="icon-cell"
                style={iconSize || iconColor ? {fontSize: iconSize, color: iconColor} : undefined}
                type={iconName as TIconType}
            />
        ));
    });

    return (
        <Space>
            {renderIcons()}
        </Space>
    );
};
